import {useCallback} from 'react';
import isNil from 'lodash/isNil';
import {statusesByStatusSets} from '../../constants/status-types';

export default ({fieldIssueTypeEntitiesMap, issueCustomAttributeMappings, issue}) => {
  const getStatusSet = useCallback(issueTypeId => {
    const issueType = fieldIssueTypeEntitiesMap[issueTypeId];
    return issueType?.statusSet;
  }, [fieldIssueTypeEntitiesMap]);

  const doesNewTypeIncludeCurrentStatus = useCallback(issueTypeId => {
    const newStatusSet = getStatusSet(issueTypeId);
    return statusesByStatusSets[newStatusSet].includes(issue.status);
  }, [getStatusSet, issue.status]);

  const getIssueCustomAttributesThatWillBeLost = useCallback(issueSubtypeId => {
    const pendingSubtype = fieldIssueTypeEntitiesMap[issueSubtypeId];
    const pendingSubtypeMappedCustomAttributes = pendingSubtype.mappingIds.map(
      mappingId => issueCustomAttributeMappings[mappingId]
    );
    return issue.customAttributes.filter(
      attribute =>
        !isNil(attribute.value) &&
        !pendingSubtypeMappedCustomAttributes.some(
          ({attributeDefinitionId}) => attributeDefinitionId === attribute.attributeDefinitionId
        )
    );
  }, [fieldIssueTypeEntitiesMap, issue.customAttributes, issueCustomAttributeMappings]);

  const getNewCustomAttributeMappings = useCallback(issueSubtypeId => {
    const pendingSubtype = fieldIssueTypeEntitiesMap[issueSubtypeId];
    const pendingSubtypeMappedCustomAttributes = pendingSubtype.mappingIds.map(
      mappingId => issueCustomAttributeMappings[mappingId]
    );
    return pendingSubtypeMappedCustomAttributes.filter(
      attribute =>
        !issue.customAttributes.some(
          ({attributeDefinitionId}) => attribute.attributeDefinitionId === attributeDefinitionId
        )
    );
  }, [fieldIssueTypeEntitiesMap, issue.customAttributes, issueCustomAttributeMappings]);
  return {
    getStatusSet,
    doesNewTypeIncludeCurrentStatus,
    getIssueCustomAttributesThatWillBeLost,
    getNewCustomAttributeMappings
  };
};
